// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Logo_logoWrapper__0wVkd","logo":"Logo_logo__KwNt8","title":"Logo_title__pusvI"};